(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('InvoiceHeaderDetailController', InvoiceHeaderDetailController);

    InvoiceHeaderDetailController.$inject = ['$scope', '$rootScope', 'previousState', 'entity'];

    function InvoiceHeaderDetailController($scope, $rootScope, previousState, entity) {
        var vm = this;

        vm.invoiceHeader = entity;
        vm.previousState = previousState.name;
        // eslint-disable-next-line
        var unsubscribe = $rootScope.$on('eDocumentsApp:invoiceHeaderUpdate', function (event, result) {
            vm.invoiceHeader = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
